import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, Loader, utils, form, authActions} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import * as opravneniActions from "../actions/opravneniActions";
import * as EnumRoleInfo from "../api/EnumRoleInfo";
import ObjectSelect from "../components/ObjectSelect";
import * as ciselnikActions from "../actions/ciselnikActions";
import CustomCheckboxField from "../components/CustomCheckboxField";
import * as uzivatelActions from "../actions/uzivatelActions";
import {isEmailNotificationsEnabled, isSmsNotificationsEnabled} from "../utils/utils";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu uživatele.
 * Pokud je aplikace v externím režimu, umožňuje editovat pouze předvolby dopravy, platby a notifikací.
 */
class UzivatelForm extends Component<WithTranslation> {

    static formName = 'UzivatelForm';

    static propTypes = {
        showPredvolby: PropTypes.bool, // zda na formuláři zobrazit i pole pro úpravu předvoleb uživatele, implicitně false
    };

    static defaultProps = {
        showPredvolby: false,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {aktivniSpolecnostId} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchPobockyUzivatelIfNeeded(aktivniSpolecnostId.data,null));
    };

    render() {
        const { onClose, submitting, handleSubmit, loggedInUser, initialValues, showPredvolby,
            zpusobyDopravyList, zpusobyPlatbyList, pobockyUzivatelList, authInfo, t } = this.props;

        if (!loggedInUser.fetched || loggedInUser.isFetching || !zpusobyDopravyList.fetched || !zpusobyPlatbyList.fetched || !pobockyUzivatelList.fetched) {
            return <Loader/>;
        }

        const editujuSebe = initialValues && loggedInUser.data.id === initialValues.id;
        const externiRezim = loggedInUser.data.extSystemRezim;
        const emailNotificationsEnabled = isEmailNotificationsEnabled(authInfo);
        const smsNotificationsEnabled = isSmsNotificationsEnabled(authInfo);

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('login')} name="loginName" disabled={submitting || externiRezim} required/>
                <ff.String label={t('title_before')} name="titulPr" disabled={submitting || externiRezim}/>
                <ff.String label={t('firstname')} name="jmeno" disabled={submitting || externiRezim} required/>
                <ff.String label={t('surname')} name="prijmeni" disabled={submitting || externiRezim} required/>
                <ff.String label={t('title_after')} name="titulZa" disabled={submitting || externiRezim}/>
                <ff.String label={t('phone')} name="telefon" disabled={submitting || externiRezim}/>
                <ff.String label={t('email')} name="email" disabled={submitting || externiRezim} required/>
                <ff.Select label={t('role')} name="role" disabled={submitting || loggedInUser.data.editaceUzivatelRoleList.length === 0 || editujuSebe || externiRezim}>
                    {loggedInUser.data.editaceUzivatelRoleList.map(r => <option value={r}>{EnumRoleInfo.getCaption(r, t)}</option>)}
                </ff.Select>
                {!editujuSebe && <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting || externiRezim}/>}
                {showPredvolby && <div>
                    <ObjectSelect
                        label={t('order.default_delivery_method')}
                        name="zpusobDopravaVychozi"
                        items={zpusobyDopravyList.rows}
                        getItemValue={(item) => item ? item.nazevDoprava : ""}
                        showEmpty={true}
                        disabled={submitting}
                    />
                    <ObjectSelect
                        label={t('order.default_payment_method')}
                        name="zpusobPlatbaVychozi"
                        items={zpusobyPlatbyList.rows}
                        getItemValue={(item) => item ? item.nazevZpusobPlatba : ""}
                        showEmpty={true}
                        disabled={submitting}
                    />
                    <ObjectSelect
                        label={t('order.default_dispensing_branch')}
                        name="pobockaVydejVychozi"
                        items={pobockyUzivatelList.rows}
                        getItemValue={(item) => item ? item.nazevPobocka : ""}
                        disabled={submitting}
                        showEmpty={true}
                    />
                    {emailNotificationsEnabled && <CustomCheckboxField label={t('order.send_notification_email')} name="notifikaceEmail" disabled={submitting}/>}
                    {smsNotificationsEnabled && <CustomCheckboxField label={t('order.send_notification_sms')} name="notifikaceSms" disabled={submitting}/>}
                </div>}
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
        pobockyUzivatelList: utils.storeFromArea(state, ciselnikActions.POBOCKY_UZIVATEL_LIST_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: UzivatelForm.formName,
    validate: (data) => utils.requireFields(["loginName", "jmeno", "prijmeni", "email"])(data),
})(UzivatelForm)));
